<template>
  <div class="authentication-page">
    <div
      class="d-flex justify-content-between vh-100 overflow-auto flex-column error-404"
    >
      <div class="contacts-overlay-img d-none d-md-block">
        <img src="@/assets/img/bg/bg-07.png" alt="img" class="img-fluid" />
      </div>
      <!-- Header -->
      <div class="authentication-header">
        <div class="container">
          <div class="col-md-12">
            <div class="text-center">
              <img src="@/assets/img/logo.svg" alt="logo" />
            </div>
          </div>
        </div>
      </div>
      <!-- /Header -->

      <!-- Main Wrapper -->
      <div class="main-wrapper">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-7 mx-auto">
              <div class="img-success d-flex justify-content-center mx-auto">
                <img src="@/assets/img/bg/error-500.png" alt="Img" class="img-fluid" />
              </div>
              <div>
                <h1 class="text-center display-6 mb-2">
                  500 Oops! Internal Server Error
                </h1>
                <div class="text-center mb-4">
                  <span class="text-gray fs-14"
                    >The server has been deserted for a while, please be patient or try
                    again later</span
                  >
                </div>
                <div class="d-flex justify-content-center">
                  <router-link to="/home/" class="btn btn-dark d-flex align-items-center"
                    ><i class="ti ti-circle-arrow-left me-1"></i>Back to Home</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Main Wrapper -->
    </div>
  </div>
</template>
